module.exports = {
  THREE_TOP_LEFT: "3 Sparkles Top Left",
  THREE_TOP_RIGHT: "3 Sparkles Top Right",
  FOUR_BOTTOM_RIGHT: "4 Sparkles Bottom Right",
  FOUR_TOP_LEFT: "4 Sparkles Top Left",
  FOUR_TOP_RIGHT: "4 Sparkles Top Right",
}
